import React from "react"

import { $patchStyleText } from "@lexical/selection"
import { $getSelection, $isRangeSelection } from "lexical"

import { ArrowDown } from "@mos-cat/ds-icons"
import { ActionsPopover, Button, Tooltip } from "@dit/core-frontend"
import { Box, Text } from "@mos-cat/ds"
import { buttonProps } from "../buttonProps"

const FONT_SIZE_OPTIONS = [
  ["10pt", "10pt"],
  ["12pt", "12pt"],
  ["14pt", "14pt"],
  ["16pt", "16pt"],
  ["18pt", "18pt"],
  ["20pt", "20pt"],
  ["22pt", "22pt"],
  ["24pt", "24pt"],
  ["26pt", "26pt"],
  ["28pt", "28pt"],
  ["30pt", "30pt"],
]

export const FontDropDown = ({ editor, editorRef, value, style }) => {
  return (
    <ActionsPopover
      portalContainer={editorRef.current}
      content={
        <Tooltip content="Размер шрифта">
          <Button
            {...buttonProps}
            kind="borderless"
            vertSize="30"
            width="50px"
            display="flex"
            justifyContent="start"
            alignItems="center"
          >
            <Box display="flex" alignItems="center" gridGap="2px">
              <Text fontSize="fs-14"> {value || FONT_SIZE_OPTIONS[0][0]}</Text>
              <Text fontSize="fs-14">
                <ArrowDown />
              </Text>
            </Box>
          </Button>
        </Tooltip>
      }
    >
      {(buttonProps) => (
        <>
          {FONT_SIZE_OPTIONS.map(([option, text]) => (
            <Button
              {...buttonProps}
              key={text}
              {...buttonProps}
              onClick={() => {
                editor.update(() => {
                  const selection = $getSelection()
                  if ($isRangeSelection(selection)) {
                    $patchStyleText(selection, {
                      [style]: option,
                    })
                  }
                })
              }}
            >
              {text}
            </Button>
          ))}
        </>
      )}
    </ActionsPopover>
  )
}
